var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69231 17.3477V12.475L15 7.61386L6 2.34766V17.3477H6.69231Z",
    fill: "#00438B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIconBlue);
export default __webpack_public_path__ + "static/media/flag-icon-blue.766ba1e147bb29568539077b920fd7e0.svg";
export { ForwardRef as ReactComponent };